module.exports = __webpack_public_path__ + "img/undTooth15.47286fbf.png";